/**
 * Created by hp on 2017/6/6.
 */
import {Component} from 'react';
import {connect} from 'react-redux';
import io from 'socket.io-client';


class ClassroomChatroom extends Component{
    socket = null;
    id = 0;

    getNewId() {
        return ++this.id;
    }

    getChatroomId(){
        const {lecture} = this.props
        let id = lecture.id
        if(lecture.parent_lecture_id){
            id = lecture.parent_lecture_id
        }
        return 'v1_' + id
    }

    onPong(data){
        const delay = Date.now() - data.pingTime
        this.props.dispatch({
            type: 'CHATROOM_SET_DELAY',
            payload: {
                networkDelay: delay
            }
        })

        this.pingTimer && clearTimeout(this.pingTimer)
        this.pingTimer = setTimeout(() => {
            this.socket.emit('custom_ping', {pingTime: Date.now()})
        }, 5000)
    }

    onChat(data){
        if(data.target !== this.getChatroomId())
            return

        const {dispatch, audioState, account} = this.props
        if(data.type === 'discuss'){
            this.props.dispatch({
                type: 'POPUP_RECEIVE',
                payload: data.discuss
            });
        }else if(data.type === 'message'){
            this.props.dispatch({
                type: 'ML_RECEIVE_MESSAGE',
                payload: data.message
            });

            // 打赏加入弹幕区
            if (data.message.type === 'reward') {
                this.props.dispatch({
                    type: 'POPUP_RECEIVE',
                    payload: data.message,
                })
            }
        }else if(data.type === 'system_message'){
            switch(data.action){
                case 'delete_discuss':
                    dispatch({type: 'POPUP_DELETE', payload: data.discuss})
                    break
                case 'delete_message':
                    dispatch({type: 'ML_DELETE_MESSAGE', payload: data.message})
                    break
                case 'set_option':
                    dispatch({type: 'CLASSROOM_SET_OPTION', payload: data.options})
                    break
                case 'select_ppt':
                    if(audioState !== 'playing'){
                        dispatch({type: 'CLASSROOM_SET_SELECTED_PPT', payload: data.ppt})
                    }
                    break;
                case 'update_popular': // 更新人气
                    dispatch({type: 'CLASSROOM_UPDATE_POPULAR', payload: data.popular});
                    break;
                case 'add_ppt': // 添加ppt
                    if( data.sender_id !== account.id ){
                        dispatch({type: 'CLASSROOM_ADD_PPT', payload: data.ppt});
                    }
                    break;
                case 'inputing':
                    dispatch({
                        type: 'CLASSROOM_SHOW_TOPNOTIFY',
                        payload: data.content
                    })
                    break;
                case 'join':
                    dispatch({
                        type: 'CLASSROOM_SHOW_TOPNOTIFY',
                        payload: data.content.account.name + '进入课堂'
                    });
                    break;
                case 'leave':
                    dispatch({
                        type: 'CLASSROOM_SHOW_TOPNOTIFY',
                        payload: data.content.account.name + '离开课堂'
                    });
                    break;
                case 'active_card':
                    let id = data.content.type + this.getNewId();
                    dispatch({
                        type: 'POPUP_RECEIVE',
                        payload: {
                            id: id,
                            type: "handleCard",
                            subtype: data.content.type,
                            content: data.content,
                        }
                    });
                    break;
                default:
                    break
            }
        }
    }

    onConnected(){
        this.props.dispatch({
            type: 'CHATROOM_SET_STATUS',
            payload: 'connected'
        });

        this.socket.emit('join', {
            chatRoomId: this.props.chatroom.chatroomId,
            lectureId: this.props.lecture.id,
            accountId: this.props.account.id,
            systemType: window.systemType, // ios or android
            clientType: 'h5',
            clientVersion: '1.0'
        });
        if(this.props.role.is_lecturer){
            this.socket.emit('custom_ping', {pingTime: Date.now()})
        }
    }

    onReconnecting(){
        this.props.dispatch({
            type: 'CHATROOM_SET_STATUS',
            payload: 'reconnecting'
        });
    }

    onDisconnect(){
        this.props.dispatch({
            type: 'CHATROOM_SET_STATUS',
            payload: 'disconnected'
        });
    }

    componentDidMount(){
        this.props.dispatch({
            type: 'CHATROOM_CONNECT',
            payload: {
                chatroomId: this.getChatroomId()
            }
        });
    }

    componentWillUpdate(nextProps){
        const {chatroom} = nextProps;
        if(this.props.chatroom.status === chatroom.status)
            return
        if(chatroom.status === 'connect'){
            this.props.dispatch({
                type: 'CHATROOM_SET_STATUS',
                payload: 'connecting'
            });

            const pushUrl = /dbg.lizhiweike.com|dbg.weike.fm/.test(location.href)
                ? 'http://dev.push.goweike.cn/socket.io'
                : 'https://push.lizhiweike.com/'

            this.socket = io(pushUrl, {
                transports: ['websocket', 'polling']
            });

            this.socket.on('chat', this.onChat.bind(this));
            this.socket.on('connect', this.onConnected.bind(this));
            this.socket.on('reconnecting', this.onReconnecting.bind(this));
            this.socket.on('disconnect', this.onDisconnect.bind(this));
            this.socket.on('custom_pong', this.onPong.bind(this));
        }
    }

    componentWillUnmount(){
        this.socket && this.socket.disconnect();
    }

    render() {
        return null;
    }
}


export default connect((state) => ({
    chatroom: state.chatroom,
    lecture: state.classroom.lecture,
    audioState: state.audioPlayer.audioState,
    role: state.classroom.role,
    account: state.account
}))(ClassroomChatroom);




// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomChatroom.js